import React, { PureComponent, Fragment } from 'react';
import { createPortal } from "react-dom";
import { CloseCircleFilled } from '@ant-design/icons';
import { Select } from 'antd';
import TreeSelect from '../../../../components/TreeSelect';
import { getGenericSpiceModelList } from '../../../../services/Sierra/library';
import Panel from '../../../../components/Panel';
import { getPanelMaxHeight, getPanelMaxWidth, getPanelWidth } from '../../../../services/helper/panelSizeHelper';
import EditableTable from '../../../../components/EditableTable';
import "../content.css";
import preLayoutData from '../../../../services/Sierra/prelayout/preLayoutData';

const Option = Select.Option;
const OptGroup = Select.OptGroup;
const tableColumns = [{
  title: 'Component Pin',
  dataIndex: 'pin',
  width: '50%'
}, {
  title: 'Subckt Node',
  dataIndex: 'node',
  width: '50%',
}];

class DiodeModelSection extends PureComponent {
  constructor(props) {
    super(props);
    const { model } = props.record;

    this.state = {
      model: { ...(model || {}) },
      maxWidth: 500,
      maxHeight: 300,
      isPower: undefined
    }

    this.dialogRoot = document.getElementById('root');
  }

  componentDidMount() {
    window.addEventListener('resize', this.resize);
    this.getPreLayoutInfo()
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resize);
  }

  componentDidUpdate = (prevProps) => {
    const { record } = this.props;
    const prevComp = prevProps.record && prevProps.record.comps && prevProps.record.comps[0] ? prevProps.record.comps[0].name : null;
    const comp = record && record.comps && record.comps[0] ? record.comps[0].name : null;
    if (comp !== prevComp) {
      this.setState({
        model: { ...(record.model || {}) },
        isUpdate: true,
        isPower: undefined
      })
      this.getPreLayoutInfo()
    }
  }

  getPreLayoutInfo = async () => {
    const { record } = this.props;
    if (record.pcbId) {
      await preLayoutData.getPreLayout(record.pcbId);

    }
    this.setState({
      isPower: this.getIsPower()
    })
  }

  getIsPower = () => {
    const { record } = this.props;
    const compName = record && record.comps && record.comps[0] ? record.comps[0].name : null;
    const comp = record.comp || compName;
    const comps = record.pcbId ? preLayoutData.getComponents(record.pcbId) : [];
    const findComp = comps.find(it => it.name === comp);
    if (findComp) {
      if (findComp.voltage && !isNaN(findComp.voltage) && parseFloat(findComp.voltage) !== 0) {
        return true;
      } else {
        return false;
      }
    }
    return undefined;
  }

  resize = () => {
    const offset = this.dialogRoot.getBoundingClientRect();
    this.setState({
      maxHeight: getPanelMaxHeight(offset, 200),
      maxWidth: getPanelMaxWidth(offset, 500)
    })
  }

  updateModel = (model) => {
    this.setState({
      model
    }, () => {
      this.saveModel()
    })
  }

  saveModel = () => {
    let model = this.state.model;
    const { record } = this.props;
    this.props.saveLibraryModel(model, record);
  }

  closeModelSelect = () => {
    this.saveModel();
    this.props.save();
  }

  updateStatus = (isUpdate) => {
    this.setState({
      isUpdate
    })
  }

  onRef = (ref) => {
    this.childRef = ref;
  }

  renderDialog() {

    const { passiveSpiceList, genericSpiceList, record, isSweep, sweepName } = this.props;
    const { model, maxWidth, maxHeight, isPower, isUpdate } = this.state;
    const comp = record && record.comps && record.comps[0] ? record.comps[0].name : null;
    const compName = record.comp || comp;
    const title = isSweep ? `${sweepName} - ` : ""
    const content = (
      <Panel
        className="sierra-diode-model-panel sierra-panel"
        title={<div className='diode-model-panel-title'>{title}{compName} - Diode Model</div>}
        onCancel={this.closeModelSelect}
        zIndex={2000}
        width={getPanelWidth(maxWidth, { defaultWidth: 500 })}
        maxWidth={maxWidth}
        maxHeight={maxHeight}
        minWidth={200}
        minHeight={200}
        position='panel-center-top'
        draggable
        overflow={"auto"}
      >
        <div className='sierra-diode-select-model-content'>
          <DiodeModelSectionContent
            onRef={this.onRef}
            model={model}
            isPower={isPower}
            isUpdate={isUpdate}
            passiveSpiceList={passiveSpiceList}
            genericSpiceList={genericSpiceList}
            updateStatus={this.updateStatus}
            updateModel={this.updateModel}
          />
        </div>
      </Panel>
    );
    return createPortal(content, this.dialogRoot)
  }

  render() {
    const { model } = this.state;
    const { text, isSweep } = this.props;
    const _text = isSweep ? text : model && model.fileName ? `${model.fileName}${model.modelName || model.subckt ? `::${model.modelName || model.subckt}` : ""}` : "";
    return (
      <Fragment>
        <div className='editable-cell-value-wrap'>
          {_text}
        </div>
        {this.renderDialog()}
      </Fragment>
    )
  }
}

export default DiodeModelSection;

class DiodeModelSectionContent extends PureComponent {
  constructor(props) {
    super(props);
    const { model } = props;
    this.state = {
      model: { ...(model || {}) },
      modelList: [],
      subcktList: [],
      maxWidth: 500,
      maxHeight: 300
    }

    this.tableColumns = JSON.parse(JSON.stringify(tableColumns));

    this.tableColumns[1].onCell = (record) => {
      const options = this.getTableNodes(record.node);
      return {
        edit: 'select',
        options,
        record,
        dataIndex: 'node',
        allowClear: true,
        dropdownMenuClassName: 'aurora-select-dropdown',
        getPopupContainer: document.getElementById("root"),
        handleSave: (_record) => this.saveNode(_record, false),
        handleClear: (_record) => this.saveNode(_record, true)
      }
    }

    this.tableColumns[0].render = (text, record) => {
      const { isPower } = this.props;
      if (text !== "VDD/GND") {
        return "Signal"
      }
      if (isPower === undefined) {
        return text
      }
      return isPower ? "VDD" : "GND";
    }
  }

  getTableNodes = (node) => {
    const { model, subcktList } = this.state;
    const findSubckt = subcktList.find(item => item.name === model.subckt);
    if (!findSubckt || !findSubckt.ports) {
      return [];
    }
    const selectedNodes = (model.pairs || []).map(item => item.node);
    const nodes = findSubckt.ports.filter(item => !selectedNodes.includes(item));
    return node ? [node, ...nodes] : nodes;
  }

  componentDidMount() {
    if (this.props.onRef) {
      this.props.onRef(this)
    }
    const { model } = this.props;
    this.setState({
      model: { ...(model || {}) },
      modelList: [],
      subcktList: []
    }, () => {
      model && model.libraryId && this.getModelParse(model.libraryId, true)
    })
    this.props.updateStatus(false)
  }

  componentDidUpdate = (prevProps) => {
    const { isUpdate, model } = this.props;
    if (isUpdate && isUpdate !== prevProps.isUpdate) {
      this.setState({
        model: { ...(model || {}) },
        modelList: [],
        subcktList: []
      }, () => {
        model && model.libraryId && this.getModelParse(model.libraryId, true)
      })
      this.props.updateStatus(false)
    }
  }

  getModel = () => {
    return this.state.model
  }

  selectModel = (file) => {
    const _file = file || {};
    this.setState({
      model: { libraryId: _file.id || "", fileName: _file.name || "", libType: "SPICE", modelName: "", subckt: "" },
      modelList: [],
      subcktList: []
    }, () => {
      this.props.updateModel(this.state.model)
      this.getModelParse(_file.id);
    })
  }

  getPairs = () => {
    return [{ pin: "signal", node: "" }, { pin: "VDD/GND", node: "" }]
  }

  getModelParse = async (libraryId, isLoad) => {
    const modelInfo = await getGenericSpiceModelList({ libraryId, onlySubckts: false });
    const models = modelInfo && modelInfo.model && modelInfo.model.models ? modelInfo.model.models : [];
    const subckts = modelInfo && modelInfo.model && modelInfo.model.subckts ? modelInfo.model.subckts : [];
    if (isLoad) {
      this.setState({
        modelList: [...models],
        subcktList: [...subckts]
      })
    } else {
      let newModel = { ...this.state.model, modelName: "", subckt: "" };
      if (models[0]) {
        newModel.modelName = models[0];
      } else if (subckts.length && subckts[0] && subckts[0].name) {
        newModel.subckt = subckts[0].name;
        newModel.pairs = this.getPairs()
      }
      this.setState({
        model: newModel,
        modelList: [...models],
        subcktList: [...subckts]
      }, () => {
        this.props.updateModel(newModel)
      })
    }
  }

  selectModelName = (key) => {
    const [name, type] = key ? key.split("::") : []
    const { model } = this.state;
    let _model = { ...model }
    if (!key) {
      _model = { ...model, modelName: "", subckt: "" }
      delete _model.pairs;
    } else {
      if (type === "subckt") {
        _model = { ..._model, modelName: "", subckt: name, pairs: this.getPairs() }
      } else {
        _model = { ..._model, modelName: name, subckt: "" }
        delete _model.pairs;
      }
    }
    this.setState({
      model: _model
    }, () => {
      this.props.updateModel(_model)
    })
  }

  saveNode = (record, isClear) => {
    const { model } = this.state;
    let pairs = model.pairs || [];
    const pinIndex = pairs.findIndex(item => item.pin === record.pin);
    if (pinIndex < 0) {
      return
    }
    pairs[pinIndex].node = isClear ? "" : record.node;
    this.setState({
      model: { ...model, pairs }
    }, () => {
      this.props.updateModel(this.state.model)
    })
  }
  render = () => {
    const { passiveSpiceList, genericSpiceList } = this.props;
    const { model, modelList, subcktList } = this.state;
    const libraryList = [{ type: "folder", name: "Passive", isTitle: true, children: [...passiveSpiceList] }, { type: "folder", name: "Generic", isTitle: true, children: [...genericSpiceList] }]

    return <div className='sierra-diode-model-selection-content'>
      <div className='diode-select-model-item'>
        <span>Model</span>
        <TreeSelect
          value={model.fileName}
          onSelectItem={(file) => this.selectModel(file)}
          showSearch
          popupClassName='aurora-select-dropdown'
          className={`aurora-select`}
          allowClear={{ clearIcon: <CloseCircleFilled onClick={(e) => this.selectModel(null, e)} /> }}
          fileList={libraryList}
          popupMatchSelectWidth={false}
          getPopupContainer={() => document.getElementById('root')}
          selected={model.libraryId}
        />
      </div>
      <div className='diode-select-model-item'>
        <span></span>
        <Select
          value={model.modelName || model.subckt}
          placeholder="Model / Subckt"
          onChange={this.selectModelName}
          className='aurora-select'
          getPopupContainer={() => document.getElementById('root')}
        >
          {this.getModelSelection(modelList, subcktList)}
        </Select>
      </div>
      {model && model.subckt ? this.getPairsTable() : null}
    </div>
  }

  getModelSelection = (modelList, subcktList) => {
    let options = []
    if (modelList.length) {
      options.push(<OptGroup key={"model"} label={"Model"}>
        {modelList.map(item => <Option key={`${item}::model`} value={`${item}::model`} title={item}>{item}</Option>)}
      </OptGroup>
      )
    }
    if (subcktList.length) {
      options.push(<OptGroup key={"subckt"} label={"Subckt"}>
        {subcktList.map(item => <Option key={`${item.name}::subckt`} value={`${item.name}::subckt`} title={item.name}>{item.name}</Option>)}
      </OptGroup>
      )
    }
    return options;
  }

  getPairsTable = () => {
    const { model } = this.state;
    return <EditableTable
      rowKey="pin"
      columns={this.tableColumns}
      size="small"
      selectType="node"
      dataSource={JSON.parse(JSON.stringify(model.pairs || []))}>
    </EditableTable>
  }
}

export {
  DiodeModelSectionContent
}